module.exports = __webpack_public_path__ + "img/dialog_close.c91473d7.svg";